import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"
import CustomTable from "../../../components/CustomTableGrid";
import Tooltip from "@material-ui/core/Tooltip";

import {
    users_get_rows, save_permission
} from "../../../store/actions/usersConfig";

import {
    Grid,
    DataTableSkeleton,
    ComposedModal,
    ModalHeader,
    ModalBody,
    RadioButton,
    Checkbox,
} from "carbon-components-react";

import moment from "moment";
import {TrashCan20} from "@carbon/icons-react";
import ModalPermission from "../../../components/ModalUser/permission";
import {set_comment} from "../../../store/actions/rh";


const columns = [
    {
        name: 'user',
        title: 'Email',
        editable: false,

        order: 0,
        height: 38
    },
    {
        name: 'createdAt',
        title: 'Data de Criação',
        editable: false,
        comment: true,

        order: 1,
        height: 38
    },
    {
        name: 'explorer',
        title: 'Explorer',
        editable: false,
        comment: true,
        width: 200,
        order: 2,
        height: 38
    },
    {
        name: 'bronze',
        title: 'Básico',
        editable: false,
        comment: true,
        width: 200,
        order: 2,
        height: 38
    },
    {
        name: 'silver',
        title: 'Padrão',
        editable: false,
        comment: true,
        width: 200,
        order: 2,
        height: 38
    },
    {
        name: 'gold',
        title: 'Avançado',
        editable: false,
        comment: true,
        width: 200,
        order: 2,
        height: 38
    },

];


class Edit extends Component {

    state = {
        form: {
            modal_permission: false,
            user: "",
            id: "",
            permission : "",
            label_permission : ""
        }
    };

    async componentDidMount() {
        try {
            await this.props.fetchData();
        } catch (e) {
            console.error(e);
        }
    }


    async savePermission(user) {
        this.setState(prevState => ({
            form: {...prevState.form, modal_permission: false}
        }))
        await this.props.fetchSavePermission({
            id: user.id,
            user: user.user,
            permission: user.permission,
        }).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_permission_save: true})
        }).catch(err => {
            return false;
        });
    }

    handleLoadingTabela = async (e) => {
        await this.props.fetchData().then(data => {
            return true;
        }).catch(err => {
            return false;
        })
    };

    onCloseModal = e => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_permission: false}
        }));
    };


    render() {

        let {data, isLoading} = this.props;
        let createdAt = moment(new Date()).format(" DD MMM YY")
        const callApi = (unmutableRows, object) => this.saveRh(unmutableRows, object);

        const callUpdatePermission = (id, user, label_permission,permission) => {
            this.setState({
                form: {
                    id: id,
                    user: user,
                    label_permission: label_permission,
                    permission: permission,
                    modal_permission: true
                },
            });
        };
        let rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        parentId: null,
                        createdAt: execution.createdAt === undefined ? " - " : moment(execution.createdAt).format("DD/MM/yyyy"),
                        type: "row",
                        explorer: <div style={{display: "inline-block", textAlign: "left"}}>
                            <Checkbox
                                checked={execution.type === "USER EXPLORER"? true: false}
                                id={"explorer"+execution._id}
                                value="standard"
                                onClick={(e) => callUpdatePermission(execution._id, execution.user, "Explorer","USER EXPLORER")}
                            />
                        </div>,
                        bronze:  <div style={{display: "inline-block", textAlign: "left"}}>
                            <Checkbox
                                checked={execution.type === "USER BRONZE"? true: false}
                                id={"bronze"+execution._id}
                                value="standard"
                                onClick={(e) => callUpdatePermission(execution._id, execution.user, "Básico","USER BRONZE")}
                            />
                        </div>,
                        silver:  <div style={{display: "inline-block", textAlign: "left"}}>
                            <Checkbox
                                checked={execution.type === "USER SILVER"? true: false}
                                id={"silver"+execution._id}
                                value="standard"
                                onClick={(e) => callUpdatePermission(execution._id, execution.user, "Padrão","USER SILVER")}
                            />
                        </div>,
                        gold:  <div style={{display: "inline-block", textAlign: "left"}}>
                            <Checkbox
                                checked={execution.type === "USER GOLD"? true: false}
                                id={"gold"+execution._id}
                                value="standard"
                                onClick={(e) => callUpdatePermission(execution._id, execution.user,"Avançado", "USER GOLD")}
                            />
                        </div>
                    };
                })
                : [];

        return (
            <Layout>
                <ModalPermission form={this.state.form}
                             onSubmitForm={(data) => this.savePermission(data)}
                             onCloseModal={(data) => this.onCloseModal(data)}
                />
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>System ADMIN</h5>
                            <h3>Configuração de usuário</h3>
                        </div>
                        <>
                            {isLoading ? (
                                <div style={{paddingTop: "30px", paddingRight: "20px", marginBottom: "50px"}}>
                                    <DataTableSkeleton/>
                                </div>
                            ) : (
                                <>
                                    {this.state.modal_permission_save && (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside
                                                       onClose={() => this.setState({modal_permission_save: false})}>
                                            <ModalHeader title="Status"/>
                                            <ModalBody>
                                                Permissão atribuida com sucesso.
                                            </ModalBody>
                                        </ComposedModal>
                                    )}

                                    <div style={{
                                        paddingTop: "30px",
                                        paddingRight: "20px",
                                        marginBottom: "50px"
                                    }}>
                                        <CustomTable headerInformation={{
                                            "title": rows.length + " usuários criados",
                                            "date": createdAt
                                        }}
                                                     unmutableRows={rows}
                                                     columns={columns}
                                                     rowsData={rows}
                                                     editable={false}
                                                     createUser={false}
                                                     callUpdatePermission={callUpdatePermission}
                                        />
                                    </div>
                                </>
                            )}
                        </>

                    </div>
                </Grid>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({usersconfig}) => usersconfig;

const
    mapDispatchToProps = dispatch => ({
        fetchData: () => dispatch(users_get_rows()),
        fetchSavePermission: (user) => dispatch(save_permission(user)),
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
